import { Message } from '@gonfalon/messages/Message';

import type { Metric } from '../../types';

interface MetricEventDefaultProps {
  metric: Metric;
}

export const MetricEventDefault: React.FC<MetricEventDefaultProps> = ({ metric }) => {
  if (!metric.eventDefault) {
    return null;
  }

  if (metric.eventDefault.disabled) {
    return (
      <span>
        <Message id="metrics.definitionSummary.excluded" />
      </span>
    );
  }

  return (
    <span>
      <Message id="metrics.definitionSummary.includedWithValue" values={{ value: metric.eventDefault.value ?? 0 }} />
    </span>
  );
};
